import React from "react"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// core components
import GridContainer from "components/GridContainer"
import GridItem from "components/GridItem"

// Assets
import userProfileStyles from "./userProfileStyles.jsx"

// Services
import {primaryColor} from "../../assets/jss/material-dashboard-pro-react.jsx";
import Table from "../../components/Table/Table.jsx";
import {get_battery_icon, get_connection_icon, time_to_h_and_min} from "../helper_functions/device_icons.js";
import ReactTimeAgo from "react-time-ago";
import {beautify_name} from "../helpers.js";
import {connect} from "react-redux";
import {deviceService} from "../../_services/index.js";
import GreenhouseMap from "../Deployment/GreenhouseMap.jsx";
import {Icon} from "leaflet";
import {CloseTwoTone, DoneTwoTone} from "@material-ui/icons";
import Tooltip from "@material-ui/core/Tooltip";
import {REFRESH_RATES, getRefreshRate} from "../../_constants/index.js";



class RobotPlatformDetail extends React.Component {
  constructor(props) {
    super(props)

    this.state = this.getInitialState()
  }

  getInitialState() {
    return {
      /** @type {import('../../_services/device.service.js').RobotPlatformStateV2 | null} Actual state of the device */
      device_state_v2: null,
      
      error_overview: [],
      last_error_refresh: null,
      last_sw_refresh: null,
      last_map_refresh: null,
      sw_info: {
        software_hash: "",
        software_manually_started: "",
        software_state: "",
        software_version: ""
      },
      has_wifi: false,
      /** @type {string | null} The current site ID of the device, or null if not available. */
      current_site_id: null,
      /** @type {string | null} The current site version of the device, or null if not available. */
      current_site_version: null,
      available_maps: {}
    }
  }

  componentDidMount() {
    this._is_mounted = true
    const {device_serial} = this.props
    this.refresh(device_serial)
  }

  componentWillUnmount() {
    clearTimeout(this.deviceStateRefresher)
    this._is_mounted = false
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.device_serial !== this.props.device_serial) {
      clearTimeout(this.deviceStateRefresher)
      //Clear state of previous device.
      this.setState(this.getInitialState())
      this.refresh(this.props.device_serial)
    }
  }

  

  refresh(device_serial) {
    deviceService.getDeviceXenionData(device_serial, res => {
      this.setState({
        has_wifi: res["has_wifi/has_wifi"],
        current_site_id: res["site/site_id"],
        current_site_version: res["site/site_version"],
      })
    })
    deviceService.getErrorOverview(device_serial, 48, res => {
      this.setState({error_overview: res.result, last_error_refresh: new Date()})
    })
    deviceService.getDeviceSwVersion(device_serial, res => {
      this.setState({sw_info: res.sw_version, last_sw_refresh: new Date()})
    })
    deviceService.getDeviceMapData(device_serial, res => {
      this.setState({
        last_map_refresh: res.time,
        available_maps: res.available_maps,
      })
    })
    this.getDeviceState(device_serial)

    
  }

  getDeviceState(device_serial) {
    deviceService.getDeviceStateV2(device_serial).then(state => {
     
      this.setState({device_state_v2: state})
    }).then(() => {
    // Auto-fetch the device state when on the device detail page
    // to get updated state information as this is can change frequently
    if (this._is_mounted) {
      this.deviceStateRefresher = setTimeout(this.getDeviceState.bind(this, device_serial), getRefreshRate(REFRESH_RATES.MEDIUM))
    }
  })

    
  }

  render() {
    const {device_serial, classes, device_name, maps} = this.props
    const {
      error_overview, device_state_v2, available_maps, has_wifi, current_site_id,
      current_site_version, last_error_refresh, last_sw_refresh, last_map_refresh, sw_info,
      
    } = this.state

   

    let sw_version = []

    if (sw_info) {
      if ("software_version" in sw_info) {
        sw_version.push([<b>Software Version</b>, sw_info["software_version"]])
      }
      if ("software_hash" in sw_info) {
        sw_version.push([<b>Software Hash</b>, sw_info["software_hash"]])
      }
      if ("software_status" in sw_info) {
        let status = sw_info["software_status"]
        let manually_started = sw_info["software_manually_started"]
        if (status === "True") {
          status = "Software Version is valid"
        }
        if (status === "False") {
          status = "Software on NUC and RPI is different"
        }
        if (status === "MissingExpected") {
          status = "The expected software version is missing on RPI or on the NUC"
        }
        if (status === "PI_error") {
          status = "There is an error with the software version on RPI"
        }
        if (status === "NUC_error") {
          status = "There is an error with the software version on RPI"
        }
        if (manually_started === true) {
          status = "Nuc and/or RPi have been started manually"
        }

        sw_version.push([<b>Software Status</b>, status])
      }
      if ("software_manually_started" in sw_info) {
        let manually_started = sw_info["software_manually_started"]

        if (manually_started === true) {
          sw_version.push([<b>Warning:</b>, "Nuc and/or RPi have been started manually"])
        }
      }
      sw_version.push(["", ""])
    }

    let maps_table = [["", "", <b>S</b>, <b>M</b>, <b>CO</b>, <b>G</b>, <b>O</b>, <b>SE</b>, <b>TO</b>, <b>UV</b>,
      <b>VE</b>, "Valid?"]]

    if (Object.keys(available_maps).length !== 0) {
      if (current_site_id && current_site_version) {
        let [base, obs, miss, gutt, uv, sen, to, con, ve] = current_site_version.split("#")
        maps_table.push([<b>Current
          Site:</b>, current_site_id, base, miss, con, gutt, obs, sen, to, uv, ve, ""])
      }

      if (available_maps) {
        Object.keys(available_maps).forEach((map_id, index) => {
          let available_map = available_maps[map_id]
          let title = <div
            key={index}
            style={{fontSize: "0.9rem"}}
          >
            <ul
              style={{fontSize: "0.9rem"}}
            >
              {Object.keys(available_map["errors"]).map((error_key, map_index) => {
                return <li key={map_index}>
                  <b>{error_key}</b>: {available_map["errors"][error_key]}
                </li>
              })
              }
            </ul>
          </div>

          let [base, obs, miss, gutt, uv, sen, to, con, ve] = available_map["version"].split("#")
          maps_table.push(
            [
              index === 0 ? <b>Other Sites:</b> : "",
              (maps && maps[map_id] ? maps[map_id]["name"] : "...") + " (" + map_id + ")",
              base, miss, con, gutt, obs, sen, to, uv, ve,
              <Tooltip
                id="tooltip2"
                title={available_map["valid"] ? "Correct Map" : title}
                placement="right"
                classes={{tooltip: classes.tooltip}}
                style={{fontSize: "0.9rem"}}
              >
                                <span
                                  style={{color: available_map["valid"] ? "rgb(100,169,68)" : "rgb(231,92,92)"}}>{available_map["valid"] ?
                                  <DoneTwoTone/> : <CloseTwoTone/>}</span>
              </Tooltip>


            ])
        })
      }
      maps_table.push(["", "", "", "", "", "", "", "", "", "", "", ""])
    }

    


    const state_render = !device_state_v2 ? (
      <GridItem xs={12} md={4}>
        <h5 style={{ color: primaryColor }}>Last Known State </h5>
        <CloseTwoTone style={{ color: "rgb(231,92,92)" }} /> No state information available
    </GridItem>
    ) : renderDeviceState(device_state_v2, classes, has_wifi)

    const hasAllLocationInfo = !!(current_site_id && current_site_version && device_state_v2)
    const location_render = !hasAllLocationInfo ? (
    <GridItem xs={12} md={12}>
        <h5 style={{ color: primaryColor }}>Current Location </h5>
        <p style={{ margin: 0 }}>
        <CloseTwoTone style={{ color: "rgb(231,92,92)", verticalAlign: "middle" }} />
        &nbsp;
        Not all location information is available.
      </p>
      <ul style={{ margin: "8px 0 0 0", paddingLeft: "20px" }}>
        <li>Map ID: {current_site_id ? current_site_id : "missing"}</li>
        <li>Map Version: {current_site_version ? current_site_version : "missing"}</li>
        <li>Device State: {device_state_v2 ? "available" : "missing"}</li>
      </ul></GridItem>
    ) : renderCurrentLocation(device_state_v2, current_site_id, current_site_version, device_name)

    return (
      <GridContainer>
        <GridItem xs={12} md={6}>
          <h5 style={{color: primaryColor}}>General</h5>
          <Table
            color={"primary"}
            tableData={[
              [
                <b>Serial Number</b>,
                device_serial
              ],
              [
                <b>Name</b>,
                <div>
                  {device_name}
                </div>
              ],
              
              ["", ""]
            ]}/>
        </GridItem>
        <GridItem xs={12} md={6}>
          <h5 style={{color: primaryColor}}>Maps </h5>
          <p> Updated: {last_map_refresh ? <ReactTimeAgo date={last_map_refresh} locale="en-UK"/> : "?"}</p>
          <Table
            color={"primary"}
            tableData={maps_table}/>
        </GridItem>
        
        <GridItem xs={12} md={4}>
          <h5 style={{color: primaryColor}}>Software Version </h5>
          <p> Updated: {last_sw_refresh ? <ReactTimeAgo date={last_sw_refresh} locale="en-UK"/> : "?"}</p>
          <Table
            color={"primary"}
            tableData={sw_version}/>
        </GridItem>
        <GridItem xs={12} md={4}>
          <h5 style={{color: primaryColor}}>Error States Last 48h </h5>
          <p> Updated: {last_error_refresh ? <ReactTimeAgo date={last_error_refresh} locale="en-UK"/> : "?"}</p>
          <Table
            color={"primary"}
            tableData={[
              [<b>Start Time</b>, <b>Stop Time</b>, <b>Duration</b>, <b>Next State</b>],
              ...error_overview.map((error_overview) => {
                return [
                  new Date(error_overview["start_time"]).toLocaleString('nl-BE'),
                  new Date(error_overview["stop_time"]).toLocaleString('nl-BE'),
                  time_to_h_and_min(error_overview["duration_seconds"]),
                  error_overview["next_state"]
                ]
              }),
              ["", "", "", ""],
            ]}/>
        </GridItem>
        
        {state_render}
        {location_render}

        
      </GridContainer>
    )
  }
}


/**
 * 
 * @param {import('../../_services/device.service.js').RobotPlatformStateV2} device_state_v2 - Actual state of the device.
 * @param {string} current_site_id - ID of the current site.
 * @param {number} current_site_version - Version of the current site.
 * @param {string} device_name - Name of the device.
 * @returns {GridItem}
 */
function renderCurrentLocation(device_state_v2, current_site_id, current_site_version, device_name) {
  const current_location_v2 = device_state_v2 ? device_state_v2.current_location : null


  let current_location_data = [["", ""]]

  if (current_location_v2) {
    current_location_data = []
    current_location_data.push([<b>Current node</b>, current_location_v2.lane_id ? current_location_v2.lane_id : ""])
    current_location_data.push([<b>Current X</b>, current_location_v2.x])
    current_location_data.push([<b>Current Y</b>, current_location_v2.y])
    current_location_data.push([<b>Current theta</b>, current_location_v2.theta])
    current_location_data.push([<b>Current velocity</b>, current_location_v2.velocity])
    current_location_data.push(["", ""])
  }

  const red_icon = new Icon({
      iconUrl: require('assets/icons/Fix.svg'),
      iconSize: [50, 50],
      iconAnchor: [25, 25],
      popupAnchor: [0, -20]
    });
  
  return <GridItem xs={12} md={12}>
    <h5 style={{ color: primaryColor }}>Current Location </h5>
    <p> Updated: {device_state_v2.timestamp ?
      <ReactTimeAgo date={device_state_v2.timestamp} locale="en-UK" /> : "?"}</p>
    <GreenhouseMap
      map_id={current_site_id}
      map_version={current_site_version}
      markers={[{
        "key": "current_position",
        "popup": device_name,
        "x": current_location_v2 ? current_location_v2.x : 0,
        "y": current_location_v2 ? current_location_v2.y : 0,
        "icon": red_icon,
      }]}
      alternate={<Table
        color={"primary"}
        tableData={current_location_data} />} />
  </GridItem>
}

/**
 * 
 * @param {import('../../_services/device.service.js').RobotPlatformStateV2} device_state_v2 - Actual state of the device.
 * @param {import('@material-ui/core/styles/withStyles').WithStyles} classes - Material-UI classes for styling.
 * @param {boolean} has_wifi - Whether the device has Wi-Fi connectivity.
 * @returns {GridItem}
 */
function renderDeviceState(device_state_v2, classes, has_wifi) {

  const state_timestamp = device_state_v2.timestamp
  const connectionStateIcon = get_connection_icon(classes, device_state_v2.is_live, state_timestamp, has_wifi)

  const batteryState = device_state_v2.battery_info ? device_state_v2.battery_info.state : null
  const batteryLevel = device_state_v2.battery_info ? device_state_v2.battery_info.level : null
  const batteryLevelRender = get_battery_icon(batteryLevel)
  const batteryStateRender = batteryState ==="error" ? <span style={{ color: 'rgb(255,0,0)' }}>Error</span>  : batteryState


  return <GridItem xs={12} md={4}>
    <h5 style={{ color: primaryColor }}>Last Known State </h5>
    <Table
      color={"primary"}
      tableData={[
        [
          <b>Last Connected</b>,
          
            <span>
              {new Date(Date.parse(state_timestamp)).toLocaleString('nl-BE')}
              &nbsp;&nbsp;(&nbsp;<ReactTimeAgo date={state_timestamp} locale="en-UK"/>&nbsp;)
              </span>
          
        ],
        [<b>Connection status</b>,
            <span style={{display: "inline-flex", alignItems: "center"}}>

            {connectionStateIcon}
            &nbsp;
            <span style={{color: device_state_v2.is_live ? "rgb(100,169,68)" : 'rgb(255,0,0)'}}>
              {device_state_v2.is_live ? "Online" : "Offline"}
            </span>
          </span>
        ],
        [
          <b>Task</b>,
          device_state_v2.state === 'error' ?
            <span
              style={{ color: 'rgb(255,0,0)' }}>{beautify_name(device_state_v2.state)} - {device_state_v2.error_code}</span>
            :
            <p>{beautify_name(device_state_v2.state)}</p>
        ],
        [
          <b>Battery Level</b>,
            batteryLevelRender
        ],
        [
          <b>Battery State</b>,
            batteryStateRender
        ],
        ["", ""]
      ]} />
  </GridItem>
}

function mapStateToProps(state) {
  const {device_serial, all_devices} = state.device_fleet
  const {maps} = state.location

  let device_name = ""
  all_devices.forEach((device) => {
    if (device["serial"] === device_serial) {
      device_name = device["name"]
      //NOTE: we could get some state info from the stored bulk state in device_fleet["device_state_v2"].
    }
  })

  return {
    device_serial, device_name, maps
  }
}

export default withStyles(userProfileStyles)(connect(mapStateToProps)(RobotPlatformDetail))
